import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { timeConvert } from 'projects/selflearnv2-ui/src/app/helpers/functions';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { LevelupDialogComponent } from '../levelup-dialog/levelup-dialog.component';
import { QuitPracticeDialogComponent } from '../quit-practice-dialog/quit-practice-dialog.component';
import { QUESTION_NOTAVAILABLE} from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { TestInstructionDialogComponent } from '../test-instruction-dialog/test-instruction-dialog.component';
import { Router } from '@angular/router';
import { toNumber } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';



@Component({
  selector: 'app-practice-questions',
  templateUrl: './practice-questions.component.html',
  styleUrls: ['./practice-questions.component.css']
})
export class PracticeQuestionsComponent implements OnInit {

  defaultQuestion: number = 0;
  disablePrev: boolean = true;
  disableNext: boolean = false;
  public flagData: any = {
    showCorrectChoice: false,
    isSolution: false,
    showSolutionBtn: false,
    isDisabled: false,
    isSelected: false,
    enableNextBtn: false,
    isPractice: true,
    isFeedback: false,
    isQuestionSubmit: false,
    isQuit: true,
    isQuestionSkipped: false,
    enableSkipBtn: false,
    localBookmarkFlag: false

  }
  public selectedData: any = {
    index: null,
    selectedQuestionData: null,
    selectedQuestionChoiceData: null,
    selectedOption: null,
    selectedOptionNumber: 0,
    reportErrorArray: []
  }
  public deviceWidth:any;
  public type: 'practice' | 'feedback' = 'practice';
  public topicAndSubTopic: any = null;
  public questionsData: Array<any> = [];
  public revCardNo: any = 0;
  public revCardData: any = {};
  public progresses: any = [];
  progIndex: number = -1;
  questionSubmitMessage: any;
  timeConvert = timeConvert
  // start of  Different question types
  matrixColumns: any = [
    ['P', 'Q', 'R', 'S'],
    ['A', 'B', 'C', 'D', 'E']
  ]
  matrixReponses: any = {};
  selectedAnswer: any = [];
  numPadDigits1To9: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  selectedNPadBtnText = '';
  selectedMultiAnswer: any = {};
  // end of Different question types
  public initialLoading = true;
  attemptedQuestion:boolean = false;
  @ViewChild("questioncontainer") questioncontainer: ElementRef;
  currentTime: number = new Date().getTime();
  questionList:any = []
  timeSpent: number=0;
  interval:any;
  showGifIcon:any = true;
  isCurrentQuestionSubmitted:boolean = false;
  isLoading:any = false;
  userDislikeStatus: boolean = false;
  userLikeStatus: boolean = false;
  constructor(public dialog: MatDialog, public selfLearnService: SelfLearnService, public router: Router,public spinner:NgxSpinnerService, public snackbar: MatSnackBar,) { }

  ngOnInit(): void {
    this.startTimer();
    this.onLevelStart();
    this.submitAndGetPracticeQuestionsV2(true);
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(!this.isCurrentQuestionSubmitted)
           this.timeSpent++;
    },1000)
  }

  quitPractice() {
    const config: MatDialogConfig = {
      // width: '620px',
      panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        correctAnswers: this.getSubtopicCount() - (this.progIndex+1),
        type: "Quit Practice",
        level: (this.getLevelFromFcq() == 4) ? 4 : this.getLevelFromFcq()+1
      }
    };
    this.dialog.open(QuitPracticeDialogComponent, config);
  }

  levelupDialog() {
    this.dialog.open(LevelupDialogComponent, { width: '440px', panelClass: ['levelup-modal'] });
  }

  submitAndGetPracticeQuestionsV2(isFromInit?:any){
    this.spinner.show();
    let payload = this.constructPayLoadForsubmitAndGetPracticeQuestionsV2();
    this.selfLearnService.submitAndGetPracticeQuestionsV2(payload).subscribe((response) => {
      if (response.data.length != 0) {
        this.timeSpent =0;
        this.questionSubmitMessage = response.message
        this.questionsData = response.data || [];
        //this.questionsData = this.questionsData.filter((item:any) => item.question_type == "single correct mcq");
        this.assignInitialValuesToQuestionsData()
        this.setLevel()
        this.startPractice(isFromInit)
        this.checkIsAttemptedQuestion()
        this.getCurrentQuestionIndexOfLevel()  
        if(localStorage.getItem('practiceLastViewQustionNumber')){
          this.showSolution();
        }
        this.spinner.hide();
      } else {
        this.questionsData = response.data || [];
        this.initialLoading = false;
        this.spinner.hide();
        this.snackbar.open('No questions found', 'Close', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'end'
        })
        this.router.navigate(['/selfLearn-V2/chapter']);
      }
      this.initialLoading = false;
    })
  }

  constructPayLoadForsubmitAndGetPracticeQuestionsV2(){
    return {
      chapterid: Number(this.selfLearnService.getChapterId()),
      examid: Number(this.selfLearnService.getCmsExamID()),
      gradeid: Number(this.selfLearnService.getGradeId()),
      subjectid: Number(this.selfLearnService.getSubjectId()),
      topicid: Number(this.selfLearnService.getTopicId()),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      timetakeninsecs: this.timeSpent,
      level: Number(this.selfLearnService.getPracticeLevel()) == 0 ? 1 : Number(this.selfLearnService.getPracticeLevel()),
    }
  }

  submitAndGetPracticeQuestionsV2Next(quesdata:any, newobj:any,isPreviousButton?:any){
    this.spinner.show();
    let payload = this.constructPayLoadForsubmitAndGetPracticeQuestionsV2Next(quesdata, newobj);
    this.selfLearnService
      .submitAndGetPracticeQuestionsV2(payload)
      .subscribe(
        (response) => {
          if (response.data.length != 0) {
            // clearInterval(this.interval);
            // this.startTimer();
            this.questionSubmitMessage = response.message
            this.questionsData = response.data || [];
            if( (((this.questionsData[this.questionsData.length -1].question_id == this.revCardData.question_id)|| response.message == "QuestionNotAvailable"))&& this.questionsData[this.questionsData.length -1].level!=4){
              this.snackbar.open('No questions found', 'Close', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'end'
              })
            }
            this.assignInitialValuesToQuestionsData(isPreviousButton? false: true);
            this.spinner.hide();
          }
          //this.getVideoSolution()
        },
        (error: any) => {
        }
      );
  }

  constructPayLoadForsubmitAndGetPracticeQuestionsV2Next(quesdata:any, newobj:any){
    return {
      chapterid: this.selfLearnService.getChapterId(),
      examid: this.selfLearnService.getCmsExamID(),
      gradeid: this.selfLearnService.getGradeId(),
      subjectid: this.selfLearnService.getSubjectId(),
      topicid: this.selfLearnService.getTopicId(),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      difficultyLevel: quesdata.difficulty_level,
      isCorrectAnswer: newobj.is_correct_answer,
      isskipped: newobj.is_skipped,
      level: quesdata.level,
      questionid: quesdata.question_id,
      subtopicid: quesdata.subtopic_id,
      timetakeninsecs:  newobj.timetakenInSecs,
      userAnswers: newobj.userAnswers==0 ? 0: newobj.userAnswers ? newobj.userAnswers : quesdata.userAnswers ,
    }
  }
   constructPayloadForBookMarkQuestion(questionData:any,isBookmarked:any){
    let payload:any = {
      chapterid: this.selfLearnService.getChapterId(),
      examid: this.selfLearnService.getCmsExamID(),
      gradeid: this.selfLearnService.getGradeId(),
      subjectid: this.selfLearnService.getSubjectId(),
      topicid: this.selfLearnService.getTopicId(),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      difficultyLevel: questionData.difficulty_level,
      level: questionData.level,
      questionid: questionData.question_id,
      subtopicid: questionData.subtopic_id,
      isbookmarked: isBookmarked,
    }
    this.selfLearnService
    .submitAndGetPracticeQuestionsV2(payload)
    .subscribe(
      (response) => {
        this.revCardData.isBookmarked = true;
      })
   }
   constructPayloadForLikeAndDisLikeQuestion(questionData:any,isLiked:any,isDisliked:any){
    if(isDisliked){
      const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
        data: {assetType:"questionFeedback",
        assetId: this.revCardData.question_id}
      });
      
      dialogRef.afterClosed().subscribe(() => {
      });
    }
    let tempRevData = this.getFCQsFromLocalStorage();
    console.log(tempRevData)
    console.log(questionData);
     tempRevData.map((question:any) => {
   if(question.question_id == questionData.question_id){  
    question.isLiked = isLiked;
    question.isDisLiked = isDisliked;
    return question;
   }})
 
     localStorage.setItem('practicequestions', JSON.stringify(tempRevData))
  
    let payload:any = {
      chapterid: this.selfLearnService.getChapterId(),
      examid: this.selfLearnService.getCmsExamID(),
      gradeid: this.selfLearnService.getGradeId(),
      subjectid: this.selfLearnService.getSubjectId(),
      topicid: this.selfLearnService.getTopicId(),
      topicName: this.selfLearnService.getTopicName(),
      chapterName: this.selfLearnService.getChapterName(),
      difficultyLevel: questionData.difficulty_level,
      level: questionData.level,
      questionid: questionData.question_id,
      subtopicid: questionData.subtopic_id,
      isLiked:isLiked ? isLiked : false,
      isDisLiked:isDisliked ? isDisliked : false
    }
    this.selfLearnService
    .submitAndGetPracticeQuestionsV2(payload)
    .subscribe(
      (response) => {
        this.revCardData.isLiked = isLiked ? isLiked: false;
        this.revCardData.isDisLiked = isDisliked ? isDisliked : false;
      })
   }

  getCurrentQuestionIndexOfLevel(){
    const fcq = this.getFCQsFromLocalStorage()
    if(fcq.length > 1){
      //this.previousQuestion()
      setTimeout(() => {
        //this.nextQuestion()
      }, 50);}
  }

  assignInitialValuesToQuestionsData(showLevlupDialougue?:any): any {
    let arr :any = [];
    let new_obj = {
      is_answer_selected: false,
      is_question_submitted: false,
      is_previous: false,
      is_skipped: false,
      is_bookmarked: false,
      is_correct_answer: false,
      userAnswers:'',
      timetakeninsecs:new Date().getTime() ,
      isLiked:false,
      isDisLiked:false,
    }
    this.questionsData.forEach(e => {
      e.new_obj = new_obj
      arr.push(e);
    });
    localStorage.setItem('practicequestions', JSON.stringify(arr))
    if(showLevlupDialougue) {this.checkTOShowLevelUpDialougue()};
  }

  setLevel(isFromInit?:any): any {
    this.progresses = []
    this.progIndex = -1;
    const subTopicCount = this.getSubtopicCount();
    for (let i = 0; i < subTopicCount; i++) {
      this.progresses.push(0);
    }
  }

  getSubtopicCount(){
    const level = ((localStorage.getItem('level')) != 'undefined') ? JSON.parse(localStorage.getItem('level')) : this.getLevelFromFcq();
    return (level > 1) ? JSON.parse(localStorage.getItem('subtopicCount')) * 1 : JSON.parse(localStorage.getItem('subtopicCount')) * 2;
  }

  getLevelFromFcq(){
    const fcq = this.getFCQsFromLocalStorage()
    return fcq[fcq.length - 1].level
  }

  startPractice(isFromInit?:any) {
    this.flagData.isPractice = true;
    let fcq = this.getFCQsFromLocalStorage()
    if(localStorage.getItem('practiceLastViewQustionNumber')){ 
        this.revCardNo =  Number(localStorage.getItem('practiceLastViewQustionNumber'));
        this.revCardData = fcq[ this.revCardNo-1];
         this.showSolution();
    }else {
      this.revCardNo = fcq.length;
      this.revCardData = fcq[fcq.length -1];
  
    }

    localStorage.setItem('level', this.revCardData.level)
    for (let i = 0; i < fcq.length; i++) {
      const e = fcq[i];
      if (e.isCorrectAnswer == true && this.revCardData.level==e.level) {
        this.progIndex += 1;
        this.progresses[this.progIndex] = 100
      }
    }
    if(isFromInit){
      if( localStorage.getItem('isItFromVideoSolution')!='true'){
        this.showStartLevelDialougue()
      }else{
        localStorage.removeItem('isItFromVideoSolution');
      }
     
      this.getVideoSolution();
    };
  }

  showStartLevelDialougue(){
    const config: MatDialogConfig = {
      width: '768px',
      panelClass: ['test-instruction-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        correctAnswers: this.getSubtopicCount() - (this.progIndex+1),
      }
    };
    this.dialog.open(TestInstructionDialogComponent, config);
  }

  checkTOShowLevelUpDialougue(){
    let fcq = this.getFCQsFromLocalStorage();
    const level = localStorage.getItem("level");
    if(fcq[fcq.length - 1].level != level) {this.nextQuestion();this.showGifIcon = true;this.showLevelUpDialougue()};
  }

  showLevelUpDialougue(){
    let fcq = this.getFCQsFromLocalStorage();
    const config: MatDialogConfig = {
      width: '440px',
      panelClass: ['levelup-modal', 'mweb-stiky-bottom'],
      data: {
        level: fcq[fcq.length - 1].level,
        correctAnswers: this.getSubtopicCount(),
      }
    };
    //this.onLevelStart();
    this.dialog.open(LevelupDialogComponent, config);
    setTimeout(() => {
      this.showGifIcon = false;
    }, 1000);
  }

  onLevelStart(){
   let time =0;
    let iconInterval = setInterval(() => {
      time = time +1
      if(time ==2){
        this.showGifIcon = false;
        clearInterval(iconInterval)
      }
  },1000)
    // $('#levelDiv').fadeOut('fast');
    // $('#levelupImg').fadeIn('fast');
    // this.onLevelStarted();
  }

  // onLevelStarted(){
  //   setTimeout(function() {
  //     $('#levelDiv').fadeIn('fast');
  //     $('#levelupImg').fadeOut('fast');
  //   }, 1700); 
  // }

  

  getFCQsFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('practicequestions')) || []
  }

  showSolution(): any {
    this.flagData.isSolution = true
  }

  showSolutionMobile(): any {
    this.flagData.isSolution = !this.flagData.isSolution
  }
 
  onSelectedAnswer(selectedQuestionData:any, selectedQuestionChoiceData:any) {
    this.flagData.isQuestionSubmit = true
    this.selectedData.selectedQuestionData = selectedQuestionData
    this.selectedData.selectedQuestionChoiceData = selectedQuestionChoiceData
  }

  saveIndex(i: any) {
    this.selectedData.index = i;
  }

  isCorrect(qc:any, option: number): boolean {
    return option === toNumber(this.revCardData.question.correct_answer);
  }

  isIncorrect(qc:any, option: number): boolean {
    return option !== toNumber(this.revCardData.question.correct_answer) && this.selectedData.selectedOptionNumber == option;
  }

  radioChange(answer: number, selectedIndex:any) {
    this.selectedData.selectedOption = answer;
    this.selectedData.selectedOptionNumber = selectedIndex
    this.flagData.isSelected = true;
    this.saveIndex(selectedIndex-1);
    // this.flagData.isDisabled = true;
  }

    nextQuestion() {
    this.flagData.isDisabled = false
    this.selectedData.index = null
     this.currentTime = new Date().getTime()
    if (this.revCardNo <= this.questionsData.length - 1) {
      this.revCardNo += 1;
      let fcq = this.getFCQsFromLocalStorage()
      this.revCardData = fcq[this.revCardNo - 1];
      this.revCardData.isBookmarked = this.revCardData.isBookmarked
      localStorage.setItem('level', this.revCardData.level)
      this.progresses = []
      this.setLevel()
    
      for (let i = 0; i < fcq.length; i++) {
        const e =fcq[i]
        e.timetakenInSecs=  this.timeSpent;
        if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
          this.progIndex += 1;
          this.progresses[this.progIndex] = 100
        }
      }
      this.questioncontainer.nativeElement.scrollTop = 0;
    } else {
      this.type = 'feedback';
    }
    this.updateCurrentQuestionTimer();
    this.checkIsAttemptedQuestion()
    this.getVideoSolution()
    this.selectedAnswer = [];
    this.selectedNPadBtnText = "";
    this.selectedMultiAnswer = {};
    console.log(this.revCardData.question.correct_answer);
  }

  previousQuestion() {
    // clearInterval(this.interval)
    // this.timeSpent = 0;
    // this.startTimer();
    this.currentTime = new Date().getTime()
    this.flagData.isDisabled = false
    this.selectedData.index = null
    this.revCardNo -= 1;
    this.flagData.enableSkipBtn = false

    let fcq = this.getFCQsFromLocalStorage()
    this.revCardData = fcq[this.revCardNo - 1];

    
    this.revCardData.isBookmarked = this.revCardData.isBookmarked
    localStorage.setItem('level', this.revCardData.level)
    this.progresses = []
    this.setLevel()
    for (let i = 0; i < fcq.length; i++) {
      const e = fcq[i];
      e.timetakenInSecs = this.timeSpent;
      if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
        this.progIndex += 1;
        this.progresses[this.progIndex] = 100
      }
    }
  
    let new_obj = {
      timetakenInSecs:this.timeSpent
    }
    this.submitAndGetPracticeQuestionsV2Next(fcq[this.revCardNo], new_obj,true);
    this.updateCurrentQuestionTimer();
    this.checkIsAttemptedQuestion()
    setTimeout(() => {
    this.questioncontainer.nativeElement.scrollTop = 0;
    }, 50);
    this.getVideoSolution()
  }

  checkIsAttemptedQuestion(): any {
    let fcq = this.getFCQsFromLocalStorage()
    if (fcq[this.revCardNo - 1].userAnswers != null) {
      this.undoConditions()
    } else {
      this.resetConditions()
    }
  }

  resetConditions(): void {
    this.selectedData.index = null
    this.flagData.showCorrectChoice = false
    this.flagData.isSolution = false
    this.flagData.showSolutionBtn = false
    this.flagData.isQuestionSubmit = false
    this.flagData.isSelected = false;
    this.flagData.enableNextBtn = false;
    this.selectedData.selectedOption = null;
  }

  undoConditions(): void {
    const data = JSON.parse(localStorage.getItem('practicequestions'))
    this.flagData.showCorrectChoice = true
    this.flagData.isSolution = false
    this.flagData.showSolutionBtn = true
    this.flagData.isQuestionSubmit = true
    this.flagData.isSelected = true;
    this.flagData.enableNextBtn = true;
    this.selectedData.selectedOptionNumber = Number(data[this.revCardNo - 1].userAnswers)
    this.isIncorrect(this.selectedData.selectedOptionNumber, toNumber((data[this.revCardNo - 1].question.correct_answer)))
    this.flagData.isDisabled = true
  }



  submitEntireLearningFlashDeck(): any {
    this.router.navigate([`selfLearn-V2/practice-completion`]);
  }

  submitSelectedQuestion(): any {
    this.attemptedQuestion = true;
    this.flagData.isQuestionSkipped = false
    this.flagData.showCorrectChoice = true
    this.flagData.showSolutionBtn = true
    this.flagData.isDisabled = true;
    this.isCurrentQuestionSubmitted = true;
    let fcq = this.getFCQsFromLocalStorage();
    let new_obj:any;
    // this.is_question_submitted = true
    if(this.revCardData.question_type =="multiple correct mcq"){
           let returnMC = false;
           let optionsChosen : any = []; 
          const keys = Object.keys(this.selectedMultiAnswer); 
         let correctArr = this.revCardData.question.correct_answer;
         let correctCheck = false;
         for (let i = 0, l = keys.length; i < l; i++) {  
           if (this.selectedMultiAnswer[keys[i]] === true) {
             optionsChosen.push(keys[i]); 
             console.log(correctArr.includes(keys[i]));
               if(!correctArr.includes(Number(keys[i])) && !returnMC){
                correctCheck = true; 
              }
          }
         }  
         this.revCardData.userAnswers = optionsChosen.toString();
          const correctOption = this.revCardData.question.correct_answer
          const  iscorrectanswer = (!correctCheck && (correctArr.length ==optionsChosen.length)) ? true : false;
              new_obj = {
               is_correct_answer: iscorrectanswer,
               is_bookmarked: this.revCardData.isBookmarked,
               is_skipped: false,
             userAnswers: optionsChosen.toString()
             }
            //  if(iscorrectanswer){
            //   this.progIndex += 1;
            //   this.progresses[this.progIndex] = 100
            //   this.progresses = []
            //   this.setLevel()
            //   let fcq = this.getFCQsFromLocalStorage()
            //   for (let i = 0; i < fcq.length; i++) {
            //     const e = fcq[i];
            //     if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
            //       this.progIndex += 1;
            //       this.progresses[this.progIndex] = 100
            //     }
            //   }
            //  }
     }else if(this.revCardData.question_type =='integer type question' || this.revCardData.question_type =='numerical value question'){
      const correctOption = toNumber((this.revCardData.question.correct_answer))
      const  iscorrectanswer = (Number(this.selectedData.selectedQuestionData[0]) === correctOption) ? true : false
       new_obj = {
        is_correct_answer: iscorrectanswer,
        is_bookmarked: this.revCardData.isBookmarked,
        is_skipped: false,
        userAnswers: Number(this.selectedData.selectedQuestionData[0])
      }
      // if(iscorrectanswer){
      //   this.progIndex += 1;
      //   this.progresses[this.progIndex] = 100
      //   this.progresses = []
      //   this.setLevel()
      //   let fcq = this.getFCQsFromLocalStorage()
      //   for (let i = 0; i < fcq.length; i++) {
      //     const e = fcq[i];
      //     if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
      //       this.progIndex += 1;
      //       this.progresses[this.progIndex] = 100
      //     }
      //   }
      // }
      }else if(this.revCardData.question_type =='single correct mcq' || this.revCardData.question_type =='assertion and reason'){
        let correctOption = toNumber((this.revCardData.question.correct_answer))
        if (this.selectedData.selectedOptionNumber === correctOption) {
          var iscorrectanswer = true
          // this.progIndex += 1;
          // this.progresses[this.progIndex] = 100
          // this.progresses = []
          // this.setLevel()
          // let fcq = this.getFCQsFromLocalStorage()
          // for (let i = 0; i < fcq.length; i++) {
          //   const e = fcq[i];
          //   if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
          //     this.progIndex += 1;
          //     this.progresses[this.progIndex] = 100
          //   }
          // }
        } else {
          var iscorrectanswer = false
        }
    
         new_obj = {
          is_correct_answer: iscorrectanswer,
          is_bookmarked: this.revCardData.isBookmarked,
          is_skipped: false,
          userAnswers: this.selectedData.index + 1,
          timetakenInSecs: this.timeSpent
      
        }

      }
    
  
    setTimeout(() => {
      // let fcq = this.getFCQsFromLocalStorage()
      // this.setLevel()
      // for (let i = 0; i < fcq.length; i++) {
      //   const e = fcq[i];
      //   if (e.isCorrectAnswer == true && e.level == JSON.parse(localStorage.getItem('level'))) {
      //     this.progIndex += 1;
      //     this.progresses[this.progIndex] = 100
      //   }
      // }
      this.submitAndGetPracticeQuestionsV2Next(fcq[this.revCardNo - 1], new_obj)
    }, 0);
    this.flagData.isQuestionSubmit = false
    this.flagData.enableNextBtn = true
   console.log(this.revCardData);
  }

  checkPracticeQuestionCompletedOrNot(): any {
    let arr:any = []
    this.progresses.forEach((p:any) => {
      if (p == 100) {
        arr.push(p)
      }
    });
    if (arr.filter((o1:any) => this.progresses.some((o2:any) => o1 === o2))) {
      return true ;
    }
  }

  getVideoSolution() {
    let findQuestionIndex = this.questionsData.findIndex(v => v?.question_id == this.revCardData?.question_id)
    if (this.questionsData[findQuestionIndex]?.question?.video_solution_id && !this.questionsData[findQuestionIndex]?.question?.video_solution_data) {
      this.questionsData[findQuestionIndex].question.video_solution_data = true;
      console.log('this.revCardData?.question: ', this.revCardData?.question);
      let params = {
        examId:this.revCardData.exam_id,
        gradeId: this.selfLearnService.getGradeId(),
        module:'practice'       
      } 
      this.selfLearnService.getVideoCms(this.revCardData?.question?.video_solution_id).subscribe((resp: any) => {
        if(resp?.video){
          resp.video.videoUrl =  resp.video.videoURL;
          resp.video.videoName = resp?.video?.title
        }
        this.questionsData[findQuestionIndex].question.video_solution_data = { ...resp?.video }
        this.questionsData[findQuestionIndex].question.duration = this.timeConvert(resp?.video?.duration||0) 
      if(this.revCardData?.question?.video_solution_id ==resp?.video?.videoId ){
        this.revCardData.question.video_solution_data={ ...resp?.video }
        this.revCardData.question.video_solution_data.duration = this.timeConvert(resp?.video?.duration||0)
      }
        this.assignInitialValuesToQuestionsData()
      })
    }
  }

  skipQuestion() {
    this.isLoading = true;
    this.flagData.isQuestionSkipped = true
    let fcq = this.getFCQsFromLocalStorage()
    this.revCardData = fcq[this.revCardNo - 1];
    
      this.skipSelectedQuestion(this.revCardData)
      //this.checkIsAttemptedQuestion()
    if (this.revCardNo == this.questionsData.length) {
      this.flagData.enableSkipBtn = false
      this.flagData.isDisabled = true
      this.selectedData.index = null
    }
    setTimeout(() => {
      if (this.revCardNo == this.questionsData.length && this.questionSubmitMessage == QUESTION_NOTAVAILABLE) {
        this.flagData.enableSkipBtn = true
      } else {
          this.isLoading =false;
          this.nextQuestion()
      }
    }, 500);
  }

    skipSelectedQuestion(skippedQuestion: any) {
    this.flagData.localBookmarkFlag = false
    this.flagData.showCorrectChoice = false
    this.flagData.showSolutionBtn = false

    let index = toNumber((this.revCardData.question.correct_answer)) - 1
    if (this.selectedData.selectedOption === this.revCardData.question.answer_options[index]) {
      var iscorrectanswer = true
    } else {
      var iscorrectanswer = false
    }

    let fcq = this.getFCQsFromLocalStorage()
    let new_obj = {
      is_skipped: true,
      timetakenInSecs:this.timeSpent
    }
    // this.revCardData.isBookmarked = this.revCardData.isBookmarked
    this.updateCurrentQuestionTimer();
    // if(skippedQuestion.isSkipped == true){
    // } else {
    //   this.submitAndGetPracticeQuestionsV2Next(fcq[this.revCardNo - 1], new_obj)
    // }
    this.submitAndGetPracticeQuestionsV2Next(fcq[this.revCardNo - 1], new_obj);
    this.flagData.isQuestionSubmit = false
    this.flagData.enableNextBtn = true
  }

  // Question type numeric
  padBtnClick(e: any, btnVal: any) {
    e.preventDefault();
    e.stopPropagation();
  
    let newAns: any;
    const currentAns:any = this.selectedAnswer || "";
    this.selectedNPadBtnText = btnVal;
    if (btnVal == "clear") {
      this.selectedNPadBtnText = "";
      this.flagData.isSelected = false;
    }else if(btnVal == "-"){
      if(this.selectedAnswer[0]==null){
        newAns = btnVal;
      }else{
        newAns = this.selectedAnswer[0];
      }
    } else {
      this.flagData.isSelected = true
      newAns = this.selectedAnswer[0] ? this.selectedAnswer[0]+btnVal : btnVal;
    }
    this.selectedAnswer = [newAns]
    console.log( this.selectedAnswer)
    this.flagData.isQuestionSubmit = true
      this.selectedData.selectedQuestionData =this.selectedAnswer
      this.selectedData.selectedQuestionChoiceData = this.selectedAnswer
  }

  getTotalQuestionCountForAllLevels(){
    const subtopicCount = JSON.parse(localStorage.getItem('subtopicCount'));
    return ((subtopicCount*5))
  }

  isDoneBtnDisabled(){
    const button = document.getElementById('doneBtn');
    //return (button) ? button['disabled'] : true;
    return (button) ? false : true;
  }
   fmtMSS(s:any){   
  return(s-(s%= 60))/60 +(9 < s ? ':':':0') + s ;      
}
updateCurrentQuestionTimer(){
  let tempQuestionData:any = this.questionsData.filter((item:any) => this.revCardData.question_id == item.question_id)
  clearInterval(this.interval)
  this.timeSpent = tempQuestionData[0].timetakenInSecs ? tempQuestionData[0].timetakenInSecs: 0;
  this.isCurrentQuestionSubmitted = tempQuestionData[0].userAnswers ? tempQuestionData[0].userAnswers : 0;
  this.startTimer();
}
redirectToVideoPage(){
  // localStorage.setItem('reviseeQuestionIds', JSON.stringify(this.questionIds));
  // localStorage.setItem('reviseQuestionsProgress',JSON.stringify(this.progress));
  localStorage.setItem('practiceLastViewQustionNumber',JSON.stringify(this.revCardNo))
  localStorage.removeItem("selfLearnSelectedPlayList");
  localStorage.removeItem("selfLearnPreviousPage", );
  localStorage.removeItem('selfLearnSelectedVideoId')
  localStorage.setItem('selectedTopicName',this.selfLearnService.getTopicName())
  localStorage.setItem("selfLearnPreviousPage", 'selfLearn-V2/practice-questions');
  localStorage.setItem('selfLearnSelectedVideoId', this.revCardData?.question?.video_solution_data.videoId)
  this.router.navigateByUrl('selfLearn-V2/videoplayback');
}
 // Question type multiple answer type
  onMultiAnswerSelect(index:any, event:any){
  console.log(index,'index')
  console.log(event.target.value,'event');
 this.selectedMultiAnswer[index+1] = true;
  this.flagData.isQuestionSubmit = true
 this.flagData.isSelected = true;

  }
 onMultiAnswerDeSelect(index:any, event:any){
  this.selectedMultiAnswer[index+1] = false;
  this.selectedData.selectedQuestionData.pop(''+(index+1))
 this.selectedData.selectedQuestionChoiceData.pop(''+(index+1))
    console.log( this.selectedMultiAnswer);
 }
checkMultiSelectAnswer(index:any){ 
   let correctans  = this.revCardData.question.correct_answer.toString();
  let mres = this.revCardData.userAnswers?.split(",");
   if(mres?.includes(String(index+1))){
      if(correctans.includes(String(index+1))){
       return 'correctAns';
    }else{
        return 'wrongAns';
      }  
    }else{
     if(correctans.includes(String(index+1))){
      return 'correctAns';
   }else{
       return '';
     }
  }
}
 checkMultiChecked(index:any){ 
  let mres = this.revCardData.userAnswers.toString();
   //mres = mres?.map((arr:any) => arr.trim());
   if(mres?.includes(String(index+1))){ 
        return true;
    }else{
       return false;
     }  
 }
 
  checkAnswer(){
    if(this.selectedData.selectedQuestionData[0]!=this.revCardData.question.correct_answer[0]){
      return false
    }else {
      return true;
    }
  }

  openUserFeedbackDialog() {
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {

      data: {assetType:"questionReport",
      assetId: this.revCardData.question_id}
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  userLike(){
    this.userLikeStatus = !this.userLikeStatus;
  }

  userDislike(){
    this.userDislikeStatus = !this.userDislikeStatus;
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"questionFeedback",
      assetId: this.revCardData.question_id}
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });
  }
 
}
